<template>
  <div class="guarantor-new">
    <div class="gua-form-step-container">
      <div class="form-scroller">
        <vue-scroll>
        <Form ref="newForm" :model="guaModel"
          :rules="modelValidate"
          label-position="right"
          :label-width="180">
          <div class="padding-top-20"></div>
          <Divider orientation="left">保函信息</Divider>
          <Row :gutter="16">
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="担保种类" prop="variety">
                <Select v-model="guaModel.variety" filterable @on-change="varietySelected" placeholder="选择担保种类">
                  <Option v-for="(tp,idx) in guaTypes" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="保函生效时间" prop="gStartDate">
                <DatePicker v-model="guaModel.gStartDate"
                  type="datetime"
                  placement="bottom-end"
                  placeholder="选择保函生效时间"
                  style="width: 200px"></DatePicker>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="保函截止时间" prop="gEndDate">
                <DatePicker v-model="guaModel.gEndDate"
                  type="datetime"
                  placement="bottom-end"
                  placeholder="选择保函截止时间"
                  style="width: 200px"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="受益人" prop="beneficiary">
                <Input v-model="guaModel.beneficiary" placeholder="输入受益人名称" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="受益人社会信用代码" prop="beneficiaryBusinessLicense">
                <Input v-model="guaModel.beneficiaryBusinessLicense" placeholder="输入受益人社会信用代码" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="受益人地址" prop="beneficiaryAddress">
                <Input v-model="guaModel.beneficiaryAddress" placeholder="输入受益人地址" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="被保证人" prop="guaranteed">
                <Input v-model="guaModel.guaranteed" placeholder="输入被保证人名称" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="被保证人社会信用代码" prop="guaranteedBusinessLicense">
                <Input v-model="guaModel.guaranteedBusinessLicense" placeholder="输入被保证人社会信用代码" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="被保证人地址" prop="guaranteedAddress">
                <Input v-model="guaModel.guaranteedAddress" placeholder="输入被保证人地址" />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="担保金额(元)" prop="amount">
                <InputNumber :min="0" :step="10000"
                  style="width: 150px;display:inline-block"
                  v-model="guaModel.amount"
                  placeholder="输入担保金额(元)"></InputNumber>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="担保费率(%·月)" prop="gFeeRate">
                <InputNumber :min="0" :step="0.1" style="width: 200px"
                  v-model="guaModel.gFeeRate"
                  placeholder="担保费率(%·月)"></InputNumber>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="担保费总额(元)" prop="fee">
                <InputNumber :min="0" :step="1000"
                  style="width: 150px;display:inline-block"
                  v-model="guaModel.fee"
                  placeholder="输入担保费总额(元)"></InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="担保方式" prop="gMethod">
                <RadioGroup v-model="guaModel.gMethod" type="button">
                  <Radio :label="0">独立保证</Radio>
                  <Radio :label="2">联合保证</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16" v-if="guaModel.gMethod===2">
            <Col span="24">
              <FormItem label="联合保证" prop="jointGuarantors">
                <div class="joint-guarantor" v-for="(joint,idx) in guaModel.jointGuarantors" :key="idx">
                  <div class="joint-guarantor-row">
                    <h3>联保人{{idx+1}}</h3>
                    <Form :ref="`jointForm`" :model="joint"
                      label-position="left"
                      inline
                      :label-width="140">
                      <FormItem label="联保人" prop="guarantorId"
                        style="width:240px"
                        :rules="[
                          { required: true, message: '请填写联保人', trigger: 'blur' }
                        ]">
                        <Select v-model="joint.guarantorId" filterable placeholder="输入关键字选择联保人">
                          <Option v-for="(ag,jIdx) in getAvaliableGuarantors(idx)" :key="jIdx" :value="parseInt(ag.guarantorId)">{{ag.guarantorName}}</Option>
                        </Select>
                      </FormItem>
                      <FormItem label="分担担保金额(元)"
                        style="width:200px"
                        prop="amount"
                        :rules="[
                          { required: true, type: 'number', message: '请填写分担担保金额', trigger: 'blur' },
                          { validator: asyncJointGuarantorAllowanceValidator, options: {model: joint}, trigger: 'change' }
                        ]">
                        <InputNumber :min="0" :step="10000"
                          style="width: 150px;display:inline-block"
                          v-model="joint.amount"
                          @on-change="changeJointAmount"
                          placeholder="输入分担担保金额(元)"></InputNumber>
                      </FormItem>
                    </Form>
                    <div class="remove-jointguarantor">
                      <Button type="error" ghost shape="circle" icon="md-trash" @click="removeJointGuarantor(joint)"></Button>
                    </div>
                  </div>
                </div>
                <Button type="text" icon="md-add" @click="addJointGuarantor">增加联保人</Button>
              </FormItem>
            </Col>
          </Row>
          <div class="padding-top-20"></div>
          <Divider orientation="left">反担保</Divider>
          <Row :gutter="16">
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="现金(元)" prop="counterCash">
                <InputNumber :min="0" style="width: 200px"
                  v-model="guaModel.counterCash" :step="10000" placeholder="现金反担保"></InputNumber>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="抵押质押(元)" prop="counterMortgage">
                <InputNumber :min="0" style="width: 200px"
                  v-model="guaModel.counterMortgage" :step="10000" placeholder="抵押质押"></InputNumber>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="第三方(元)" prop="counter3rdparty">
                <InputNumber :min="0" style="width: 200px"
                  v-model="guaModel.counter3rdparty" :step="10000" placeholder="第三方反担保"></InputNumber>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="其他(元)" prop="counterOther">
                <InputNumber :min="0" style="width: 200px"
                  v-model="guaModel.counterOther" :step="10000" placeholder="其他反担保"></InputNumber>
              </FormItem>
            </Col>
          </Row>
          <div class="padding-top-20"></div>
          <Divider orientation="left">联系人</Divider>
          <Row :gutter="16">
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="上报人" prop="opName">
                <Input v-model="guaModel.opName" placeholder="输入上报人" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8">
              <FormItem label="联系电话" prop="opContactTel">
                <Input v-model="guaModel.opContactTel" placeholder="输入联系电话" />
              </FormItem>
            </Col>
          </Row>
          <div class="padding-top-20"></div>
        </Form>
        </vue-scroll>
      </div>

      <div class="bottom-buttons">
        <Row :gutter="16">
          <Col span="4"><Button type="primary" ghost size="large" style="display:inline" long @click="backward">上一步</Button></Col>
          <Col span="16"><Button type="primary" size="large" style="display:inline" long @click="submit">下一步</Button></Col>
          <Col span="4"><Button type="info" size="large" style="display:inline" long @click="draft">存草稿</Button></Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
// import Api from './../../api/Api.js'
export default {
  name: 'guarantor-new-puyang-step2',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      guaModel: {
        beneficiary: null,
        beneficiaryBusinessLicense: null,
        beneficiaryAddress: null,
        guaranteed: null,
        guaranteedBusinessLicense: null,
        guaranteedAddress: null,
        amount: 0,
        fee: null,
        variety: 0,
        amountCostRatio: 0,
        counterCash: 0,
        counter3rdparty: 0,
        counterMortgage: 0,
        counterOther: 0,
        counterRatio: 0,
        gMethod: 0,
        gStartDate: null,
        gEndDate: null,
        gFeeRate: 0,
        opName: null,
        opContactTel: null,
        contractOssKeys: [],
        attachments: [],
        jointGuarantors: []
      },
      modelValidate: {
        variety: [
          { required: true, type: 'number', message: '请选择担保种类', trigger: 'change' }
        ],
        beneficiary: [
          { required: true, message: '请填写受益人', trigger: 'blur' }
        ],
        beneficiaryBusinessLicense: [
          { required: true, message: '请填写受益人社会信用代码', trigger: 'blur' }
        ],
        guaranteed: [
          { required: true, message: '请填写被保证人', trigger: 'blur' }
        ],
        guaranteedBusinessLicense: [
          { required: true, message: '请填写被保证人社会信用代码', trigger: 'blur' }
        ],
        amount: [
          { required: true, type: 'number', message: '请填写担保金额', trigger: 'blur' }
        ],
        gStartDate: [
          { required: true, type: 'date', message: '请填写起始日期', trigger: 'change' }
        ],
        gEndDate: [
          { required: true, type: 'date', message: '请填写截止日期', trigger: 'change' }
        ],
        gFeeRate: [
          { required: true, type: 'number', message: '请填写费率', trigger: 'blur' }
        ],
        opName: [
          { required: true, message: '请填写上报人', trigger: 'blur' }
        ],
        opContactTel: [
          { required: true, message: '请填写联系方式', trigger: 'blur' }
        ]
      },
      guaTypes: [],
      avaliableGuarantors: []
    }
  },
  watch: {
    'guaModel.gMethod': function (newVal) {
      if (newVal === 2) {
        this.showJointGuarantorTip()
      } else if (newVal !== 2) {
        this.guaModel.jointGuarantors = []
      }
    },
    'guaModel.gFeeRate': function () {
      this.reCalcFee()
      this.checkFeeRate()
    },
    'guaModel.gStartDate': function () {
      this.reCalcFee()
    },
    'guaModel.gEndDate': function () {
      this.reCalcFee()
    },
    'guaModel.amount': function () {
      this.reCalcRatios()
      this.checkAmountAllowance()
      this.reCalcFee()
    },
    'guaModel.counterCash': function () { this.reCalcRatios() },
    'guaModel.counterMortgage': function () { this.reCalcRatios() },
    'guaModel.counter3rdparty': function () { this.reCalcRatios() },
    'guaModel.counterOther': function () { this.reCalcRatios() }
  },
  mounted () {
    if (!this.data.cityId) {
      this.$router.push({path: '/guarantees/new-puyang/step1'})
    } else {
      // Copy from data if available (always copy when data exists)
      if (this.data.amount || this.data.beneficiary) {
        let copyData = JSON.parse(JSON.stringify(this.data))
        Object.assign(this.guaModel, copyData)
      }
    }
    this.initGuaTypes()
    // Pre-fill user info
    if (!this.guaModel.opName) {
      this.guaModel.opName = this.$store.getters.userInfo.displayName
    }
    if (!this.guaModel.opContactTel) {
      this.guaModel.opContactTel = this.$store.getters.userInfo.mobile
    }
    if (this.guaModel.gStartDate) {
      this.guaModel.gStartDate = new Date(this.guaModel.gStartDate)
    }
    if (this.guaModel.gEndDate) {
      this.guaModel.gEndDate = new Date(this.guaModel.gEndDate)
    }
    // Convert from cents to yuan when returning from step3
    if (this.guaModel.amount) {
      this.guaModel.amount /= 100
    }
    if (this.guaModel.fee) {
      this.guaModel.fee /= 100
    }
    if (this.guaModel.counterCash) {
      this.guaModel.counterCash /= 100
    }
    if (this.guaModel.counterMortgage) {
      this.guaModel.counterMortgage /= 100
    }
    if (this.guaModel.counter3rdparty) {
      this.guaModel.counter3rdparty /= 100
    }
    if (this.guaModel.counterOther) {
      this.guaModel.counterOther /= 100
    }
    if (this.guaModel.jointGuarantors && this.guaModel.jointGuarantors instanceof Array) {
      this.guaModel.jointGuarantors.forEach(j => {
        if (j.amount) j.amount /= 100
      })
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    backward () {
      this.$emit('go-backward')
    },
    showJointGuarantorTip () {
      this.$Modal.confirm({
        title: '联合保证模式说明',
        content: '联合保证模式下，最终提交的担保总额为主保保额+各联保方承担份额总额，主表单担保金额填写主保方（我方）独自承担的担保份额',
        okText: '我已知晓',
        cancelText: '取消',
        onOk: () => {
          this.listAvaliableJointGuarantors()
        }
      })
    },
    async initGuaTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.getGuaranteeVarieties().then(res => {
          this.guaTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    reCalcFee () {
      if (this.guaModel.gStartDate && this.guaModel.gEndDate && this.guaModel.gFeeRate) {
        let days = this.$moment(this.guaModel.gEndDate).diff(this.$moment(this.guaModel.gStartDate), 'days')
        let months = Math.ceil(days / 30)
        let fee = Math.round(this.guaModel.gFeeRate * months * this.guaModel.amount) / 100
        this.guaModel.fee = fee
      } else {
        this.guaModel.fee = 0
      }
    },
    reCalcRatios () {
      let totalAmount = this.guaModel.amount || 0
      if (this.guaModel.jointGuarantors && this.guaModel.jointGuarantors instanceof Array) {
        this.guaModel.jointGuarantors.forEach((j) => {
          totalAmount += (j.amount || 0)
        })
      }
      if (totalAmount && this.data && this.data.project && this.data.project.cost) {
        this.guaModel.amountCostRatio = Math.round(totalAmount / (this.data.project.cost) * 10000) / 100
      } else {
        this.guaModel.amountCostRatio = 0
      }
      let counterTotal = (this.guaModel.counterCash || 0) + (this.guaModel.counterMortgage || 0) +
        (this.guaModel.counter3rdparty || 0) + (this.guaModel.counterOther || 0)
      if (totalAmount && counterTotal > 0) {
        this.guaModel.counterRatio = Math.round(counterTotal / totalAmount * 10000) / 10000
      } else {
        this.guaModel.counterRatio = 0
      }
    },
    async checkAmountAllowance () {
      if (!this.guaModel.amount) return
      try {
        let guarantorId = this.$store.getters.guarantorInfo.id
        let res = await this.$Api.Guarantee.checkAllowance(
          this.guaModel.amount * 100,
          guarantorId,
          this.data.cityId,
          this.data.industryId
        )
        if (!res) {
          this.$Message.warning('担保金额超过限制')
        }
      } catch (e) {
        // Ignore check failure, just show warning
      }
    },
    async checkFeeRate () {
      if (!this.guaModel.gFeeRate) return
      try {
        let guarantorId = this.$store.getters.guarantorInfo.id
        let res = await this.$Api.Guarantee.checkMinRate(
          this.guaModel.gFeeRate * 1000000,
          guarantorId,
          this.data.cityId,
          this.data.industryId
        )
        if (!res) {
          this.$Message.warning('担保费率低于最低要求')
        }
      } catch (e) {
        // Ignore check failure, just show warning
      }
    },
    varietySelected (varietyId) {
      if (!varietyId || !this.data) return
      // Get variety name from guaTypes
      let variety = this.guaTypes.find(v => parseInt(v.id) === varietyId)
      if (!variety) return
      let name = variety.fullName || variety.name || ''

      // Category 1: 投标担保, 总（专业）承包商履约担保, 建筑务工人员工资支付保证金担保, 工程质量保证, 农民工保证金（现金）
      // Beneficiary = Owner, Guaranteed = Contractor
      if (['投标担保', '总（专业）承包商履约担保', '建筑务工人员工资支付保证金担保', '工程质量保证', '农民工保证金（现金）'].some(v => name.includes(v))) {
        this.setBeneficiaryGuaranteed(
          this.data.owner ? this.data.owner.name : null,
          this.data.owner ? this.data.owner.businessLicense : null,
          this.data.contractor ? this.data.contractor.name : null,
          this.data.contractor ? this.data.contractor.businessLicense : null
        )
      }
      // Category 2: 业主支付工程款担保, 总（专业）承包商付款（供货）担保
      // Beneficiary = Contractor, Guaranteed = Owner
      else if (['业主支付工程款担保', '总（专业）承包商付款（供货）担保'].some(v => name.includes(v))) {
        this.setBeneficiaryGuaranteed(
          this.data.contractor ? this.data.contractor.name : null,
          this.data.contractor ? this.data.contractor.businessLicense : null,
          this.data.owner ? this.data.owner.name : null,
          this.data.owner ? this.data.owner.businessLicense : null
        )
      }
      // Category 3: 专业（劳务）分包商履约担保, 总（专业）承包商付款（分包）担保
      // Beneficiary = Contractor, Guaranteed = empty
      else if (['专业（劳务）分包商履约担保', '总（专业）承包商付款（分包）担保'].some(v => name.includes(v))) {
        this.setBeneficiaryGuaranteed(
          this.data.contractor ? this.data.contractor.name : null,
          this.data.contractor ? this.data.contractor.businessLicense : null,
          null,
          null
        )
      }
    },
    setBeneficiaryGuaranteed (beneficiary, beneficiaryBL, guaranteed, guaranteedBL) {
      this.guaModel.beneficiary = beneficiary
      this.guaModel.beneficiaryBusinessLicense = beneficiaryBL
      this.guaModel.guaranteed = guaranteed
      this.guaModel.guaranteedBusinessLicense = guaranteedBL
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          // 额外检查保额和费率是否超过限制
          let amountValid = await this.checkAmountAllowanceSubmit()
          if (!amountValid) {
            this.$Message.error('担保金额超过限额，不允许进入下一步')
            return
          }
          let rateValid = await this.checkFeeRateSubmit()
          if (!rateValid) {
            this.$Message.error('担保费率低于最低要求，不允许进入下一步')
            return
          }
          // 检查联保方保额和费率
          if (this.guaModel.gMethod === 2 && this.guaModel.jointGuarantors) {
            for (let joint of this.guaModel.jointGuarantors) {
              if (!joint.guarantorId || !joint.amount) continue
              try {
                let res = await this.$Api.Guarantee.checkAllowance(
                  joint.amount * 100,
                  joint.guarantorId,
                  this.data.cityId,
                  this.data.industryId
                )
                if (!res) {
                  this.$Message.error('联保方分担担保金额超过限额，不允许进入下一步')
                  return
                }
              } catch (e) {
                // 忽略检查失败
              }
            }
          }
          if (this.guaModel.gMethod === 2) {
            this.$Modal.confirm({
              title: '请确认',
              content: '联合保证模式下，最终提交的担保总额为主保保额+各联保方承担份额总额，主表单担保金额填写主保方（我方）独自承担的担保份额',
              okText: '确认提交',
              cancelText: '取消',
              onOk: () => {
                this.doSubmit()
              }
            })
          } else {
            this.doSubmit()
          }
        }
      })
    },
    async checkAmountAllowanceSubmit () {
      if (!this.guaModel.amount) return true
      try {
        let guarantorId = this.$store.getters.guarantorInfo.id
        let res = await this.$Api.Guarantee.checkAllowance(
          this.guaModel.amount * 100,
          guarantorId,
          this.data.cityId,
          this.data.industryId
        )
        return !!res
      } catch (e) {
        return true // 检查失败时默认放行
      }
    },
    async checkFeeRateSubmit () {
      if (!this.guaModel.gFeeRate) return true
      try {
        let guarantorId = this.$store.getters.guarantorInfo.id
        let res = await this.$Api.Guarantee.checkMinRate(
          this.guaModel.gFeeRate * 1000000,
          guarantorId,
          this.data.cityId,
          this.data.industryId
        )
        return !!res
      } catch (e) {
        return true // 检查失败时默认放行
      }
    },
    doSubmit () {
      let model = JSON.parse(JSON.stringify(this.guaModel))
      // Convert to cents
      model.amount *= 100
      if (model.fee) model.fee *= 100
      model.counterCash *= 100
      model.counterMortgage *= 100
      model.counter3rdparty *= 100
      model.counterOther *= 100
      model.gStartDate = require('moment')(this.guaModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')
      model.gEndDate = require('moment')(this.guaModel.gEndDate).format('YYYY-MM-DD HH:mm:ss')
      // Add prjId, ownerId, contractorId
      model.prjId = this.data.project ? this.data.project.id : null
      model.ownerId = this.data.owner ? this.data.owner.tid : null
      model.contractorId = this.data.contractor ? this.data.contractor.tid : null
      // Convert joint guarantors amounts to cents
      if (model.jointGuarantors && model.jointGuarantors instanceof Array) {
        model.jointGuarantors.forEach((j) => {
          j.amount *= 100
        })
      }
      this.$emit('finish-step2', model)
    },
    async draft () {
      if (!this.guaModel.gStartDate || !this.guaModel.gEndDate) {
        this.$Message.error('保函起止日期不能为空')
        return false
      }
      let draft = JSON.parse(JSON.stringify(this.guaModel))
      draft.amount *= 100
      if (draft.fee) draft.fee *= 100
      draft.counterCash *= 100
      draft.counterMortgage *= 100
      draft.counter3rdparty *= 100
      draft.counterOther *= 100
      draft.gStartDate = require('moment')(this.guaModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')
      draft.gEndDate = require('moment')(this.guaModel.gEndDate).format('YYYY-MM-DD HH:mm:ss')
      draft.cityId = this.data.cityId
      draft.industryId = this.data.industryId
      draft.project = this.data.project
      draft.owner = this.data.owner
      draft.contractor = this.data.contractor
      // Add prjId, ownerId, contractorId
      draft.prjId = this.data.project ? this.data.project.id : null
      draft.ownerId = this.data.owner ? this.data.owner.tid : null
      draft.contractorId = this.data.contractor ? this.data.contractor.tid : null
      if (!draft.guarantorId) {
        draft.guarantorId = this.$store.getters.guarantorInfo.id
      }
      // Convert joint guarantors amounts to cents
      if (draft.jointGuarantors && draft.jointGuarantors instanceof Array) {
        draft.jointGuarantors.forEach((j) => {
          j.amount *= 100
        })
      }
      if (this.data.id) {
        draft.id = this.data.id
      }
      this.$Spin.show()
      this.$Api.Guarantee.draftGuarantee(draft).then(() => {
        this.$Message.success('操作成功')
        this.$Spin.hide()
        this.$router.push('/guarantees/list')
      }).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
    },
    async listAvaliableJointGuarantors () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantor.listJointGuarantors(this.data.cityId, this.data.industryId).then(res => {
          this.avaliableGuarantors = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    getAvaliableGuarantors (idx) {
      let selectedGuarantors = this.guaModel.jointGuarantors.map((j, index) => {
        if (index !== idx) {
          return j.guarantorId
        }
      })
      return this.avaliableGuarantors.filter((g) => {
        return selectedGuarantors.indexOf(g.guarantorId) < 0
      })
    },
    asyncJointGuarantorAllowanceValidator (rule, value, callback) {
      let opt = rule.options
      let guarantorId = opt.model.guarantorId
      this.$Api.Guarantee.checkAllowance(value * 100, guarantorId, this.data.cityId, this.data.industryId)
      .then((res) => {
        if (res) {
          callback()
        } else {
          callback(new Error('超出限额'))
        }
      }).catch(err => {
        callback(err)
      })
    },
    changeJointAmount () {
      this.reCalcRatios()
    },
    addJointGuarantor () {
      if (!this.guaModel.jointGuarantors || !(this.guaModel.jointGuarantors instanceof Array)) {
        this.guaModel.jointGuarantors = []
      }
      this.guaModel.jointGuarantors.push({
        guarantorId: null,
        amount: null
      })
      this.reCalcRatios()
    },
    removeJointGuarantor (g) {
      this.guaModel.jointGuarantors.splice(this.guaModel.jointGuarantors.indexOf(g), 1)
      this.reCalcRatios()
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new {
  position: relative;
  height: 100%;
}
.gua-form-step-container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  .form-scroller {
    flex: 1;
    overflow: auto;
  }
  .bottom-buttons {
  }
}
.joint-guarantor {
  margin-bottom: 10px;
  .joint-guarantor-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    h3 {
      margin-right: 10px;
      min-width: 80px;
    }
    .remove-jointguarantor {
      margin-left: 10px;
    }
  }
}
</style>